import React from 'react';
import { Link } from 'react-router-dom';
import { Hero } from '../Hero';
import { MacroBalanced } from '../MacroBalanced';
import { AllergenConscious } from '../AllergenConscious';

/**
 * Home page — the conversion scroll. Hero → what it is → Macros → a call to
 * order direct (Join the Club). Everything else lives on its own page
 * (Recipes, Story, Team).
 */
export function HomePage() {
  return (
    <>
      <Hero />

      {/* The format statement. Search and answer engines currently classify
          TrueNooch as nutritional yeast — a powder you sprinkle — and describe
          it from Reddit rather than from us, because the site never says in
          plain prose what the thing physically is. This block is that sentence,
          placed directly after the hero so it sits in the first body copy a
          crawler reads.

          2026-09-13 — REWRITTEN to the deck's front slide (marketing/deck/slides/
          00-the-pitch.html, spoken by Jarvis and recorded 2026-09-07). The old
          heading was "Not a powder. A food you slice." That was written when the
          Round was the only form; TrueNooch Flour IS a powder, so the site was
          about to contradict a product on the table. His call: lead with
          INGREDIENT, which is true of every form and still does the work of
          separating us from a shaker of nutritional yeast — the distinction was
          never powder-vs-solid, it is seasoning-you-sprinkle vs food-you-cook-with.

          Deliberately NOT `fade-in`: that class starts at opacity 0 and only
          clears on an IntersectionObserver hit, so a renderer that never
          scrolls would snapshot it invisible. Being read is this block's
          entire job. */}
      <section className="section" style={{ paddingTop: '2.5rem', paddingBottom: '0.5rem' }}>
        <div className="section-label">What it is</div>
        <h2>TrueNooch&trade; is an ingredient.</h2>
        <p style={{ maxWidth: '58ch' }}>
          You cook with it — whatever’s already on your plate. Sandwiches, pasta, dumplings. Next
          to meat, or keep it vegan. And it’s good on its own: slice a piece off the Round and eat
          it as is.
        </p>
        <p style={{ maxWidth: '58ch' }}>
          It comes in three forms, all the same food — a firm Round you slice, cubes that travel,
          and a flour you bake with. Nutritional yeast is one of the eight ingredients we cook
          with, not what TrueNooch&trade; is: this is a made food, not a seasoning you sprinkle on
          top.
        </p>
        <p style={{ maxWidth: '58ch' }}>
          <strong>Eight ingredients. I cook it.</strong>
        </p>
      </section>

      <MacroBalanced />
      <AllergenConscious />
      <section className="section fade-in" style={{ paddingTop: '2rem' }}>
        <div className="signup">
          <h3>Order TrueNooch&trade; direct.</h3>
          <p>We’re making it in small batches in Colorado — and selling direct. Join the club for first dibs, and be one of our founding regulars.</p>
          <Link className="club-cta" to="/club">Join the Club →</Link>
        </div>
      </section>
    </>
  );
}
